import styled from '@emotion/styled'

export const SliderElement = styled.div`
  margin-right: 12px;
  min-width: 98px;
  outline: none;
`
